import { Injectable } from '@angular/core';
import { DeviceTask } from '@era/device-task-management-sdk';
import { Store } from '@ngrx/store';
import { first, map, tap } from 'rxjs';
import { DeviceScheduledTasksStoreActions } from './index';
import { DevicesRouterStoreSelectors, RouterStoreStates } from '../../../../stores/router';

@Injectable()
export class DeviceScheduledTasksResolver {
  constructor(
    private readonly scheduledTasks: Store<DeviceTask>,
    private readonly routerStore: Store<RouterStoreStates.RouterState>
  ) {}

  resolve() {
    return this.routerStore.select(DevicesRouterStoreSelectors.selectUdid).pipe(
      tap((udid) => {
        this.scheduledTasks.dispatch(
          DeviceScheduledTasksStoreActions.DeviceScheduledTasksResolverActions.scheduledTasksRequested({ udid })
        );
      }),
      map(() => true),
      first()
    );
  }
}
